module.exports = __webpack_public_path__ + "static/media/irteza.f0fe5603.jpg";